import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import { AuthProvider } from "./contexts/AuthContext";
import { WorkspaceProvider } from "./contexts/WorkspaceContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AppShell } from "./components/AppShell";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { JoinWorkspace } from "./pages/JoinWorkspace";
import { Dashboard } from "./pages/Dashboard";
import { Timer } from "./pages/Timer";
import { Timesheets } from "./pages/Timesheets";
import { Analytics } from "./pages/Analytics";
import { Workspace } from "./pages/Workspace";
import { Settings } from "./pages/Settings";

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WorkspaceProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/join/:token" element={<JoinWorkspace />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/timer" element={<Timer />} />
                <Route path="/timesheets" element={<Timesheets />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/workspace" element={<Workspace />} />
                <Route path="/settings" element={<Settings />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </WorkspaceProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
